import { render, staticRenderFns } from "./ModalCropper.vue?vue&type=template&id=1651d751"
import script from "./ModalCropper.vue?vue&type=script&lang=js"
export * from "./ModalCropper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports